/**
 * @Author       : baomeiling
 * @Date         : 2022-05-24 18:02:02
 * @LastEditTime : 2022-05-26 11:47:56
 * @LastEditors  : baomeiling
 * @Description  : 
 * @FilePath     : \iristar-official-website\src\assets\product\productList.js
 */
const productList = [
    // {
    //     imgPo: "imgLeft",
    //     showToHome: true,
    //     index: 3,
    //     scale: "1-2",
    //     toHomeImg: "/static/img/product/6.png",
    //     type: "S320-T1",
    //     name: "虹膜识别温度监测一体机",
    //     title: "虹膜识别温度监测一体机",
    //     img: "/static/img/product/10.png",
    //     point: ["无接触检测，安全卫生", "识别效果，准确高效", "即插即用，快速部署"],
    //     desc:
    //         "S320-T1虹膜测温门禁集红外测温、虹膜识别、人脸识别于一体，对佩戴口罩、护目镜等高度防护的人员进行快速体温筛查与精准身份识别，既可完成体温异常人员的预警，同时可快速锁定体温异常人员近期接触者身份，实现流动人员的高效安全门禁管控。特别适合于机场、车站等交通枢纽；医院、学校、政府楼宇门禁；工厂、企业、社区出入口等。",
    //     fc: [
    //         { img: "", name: "园区管理" },
    //         { img: "", name: "考勤打卡" },
    //     ],
    //     btn: {
    //         show: true,
    //         text: "查看详情",
    //     },
    //     param: [
    //         { key: "产品型号", val: "S320-T1" },
    //         { key: "产品尺寸", val: "160mm*260mm*45mm（宽*高*厚）" },
    //         { key: "屏幕", val: "标配7寸触摸屏" },
    //         { key: "识别距离", val: "身份识别：45~65cm / 体温检测：＜5cm" },
    //         {
    //             key: "识别身高范围",
    //             val: "支持根据用户身高自行调节，可覆盖40cm",
    //         },
    //         { key: "注册时间", val: "虹膜+人脸＜3S" },
    //         { key: "识别时间", val: "身份识别+温度检测＜2S" },
    //         {
    //             key: "识别精度",
    //             val: "身份识别：误识率为0.00001%时，拒识率≤0.1% / 体温检测：±0.3℃",
    //         },
    //         {
    //             key: "终端注册数据库",
    //             val: "标准1万用户的数据（可根据用户需求定制）",
    //         },
    //         { key: "近红外光源", val: "近红外光，LED光源符合IEC-62471标准" },
    //         { key: "虹膜图像", val: "符合IS029794-6和ISO19794-6标准" },
    //         { key: "人脸图像", val: "符合IS029794-5和ISO19794-5标准" },
    //         { key: "语音提示（灯光）", val: "支持" },
    //     ],
    // },

    {
        imgPo: "imgLeft",
        showToHome: true,
        index: 5,
        toHomeImg: "/static/img/product/55.png",
        type: "S200P",
        name: "混合生物特征识别一体机",
        title: "混合生物特征识别一体机",
        img: "/static/img/product/1.png",
        point: ["优雅的造型", "完美的曲线", "摆脱冰冷工业外观设计"],
        desc:
            "S200P混合生物特征识别一体机造型美观大方，与诸多高端场景相得益彰，可结合虹星科技信息管理系统，将身份信息注册识别、实时数据处理和后台信息管理有效结合，对员工考勤打卡、员工通行记录、黑白名单管理、外来访客、重要区域权限进行统一管理。",
        fc: [
            { img: "", name: "智能楼宇" },
            { img: "", name: "VIP客户" },
        ],
        btn: {
            show: true,
            text: "查看详情",
        },
        param: [
            { key: "产品型号", val: "S200P" },
            { key: "产品尺寸", val: "高1850mm、底座直径400mm" },
            { key: "产品形态", val: "立柱" },
            { key: "工作温度", val: "0~45℃" },
            { key: "工作湿度", val: "0-90% RH，不结露" },
            { key: "数据信息管理系统", val: "IriStar Cetus Device 管理平台" },
            { key: "识别方式", val: "远距离虹膜识别、人脸识别、活体检测" },
            {
                key: "活体检测",
                val: "支持静默活体检测/支持打印/显示屏/美瞳/脸膜等假体检测",
            },
            { key: "注册时间", val: "<3s" },
            { key: "识别时间", val: "<1s" },
            { key: "识别环境", val: "室内、夜晚、逆光均可" },
            { key: "操作系统", val: "Windows 7 64-bit 及以上/Linux/Android" },
            { key: "识别模式", val: "1:N / 1:1" },
            { key: "识别距离", val: "1m~1.2m" },
            {
                key: "虹膜识别身高范围",
                val: "1.55~1.85m(可定制，最大1.3~1.95m，支持电动身高范围调节)",
            },
            { key: "识别误识率", val: "0.00001%" },
            { key: "识别拒识率", val: "0.1%" },
            { key: "虹膜图像", val: "符合ISO29794-6和ISO19794-6标准" },
            { key: "人脸图像", val: "符合ISO29794-5和ISO19794-5标准" },
            {
                key: "近红外光源",
                val: "LED光源符合IEC62471: 2006 无伤害类标准",
            },
            { key: "工作模式", val: "单机模式/联网模式" },
        ],
    },
    {
        imgPo: "imgLeft",
        type: "S260P",
        name: "驾驶员身份识别一体机",
        title: "驾驶员身份识别一体机",
        img: "/static/img/product/5.png",
        point: ["人车识别二合一", "无须下车", "只需一眼"],
        desc:
            "S260P 是专为只能出行打造的生物特征识别一体机，可与车牌识别设备结合，高效完成人车一体识别，在体验感和性能、成本上均达到了可商业化应用的程度。S260P采用户外环境设计，适应各种室外光照条件，具备良好的防水防尘效果。产品外观设计与车牌识别产品风格一致，利于集成，架设高度也可予以调整，以适应驾驶各类车型的司机识别。",
        fc: [
            { img: "", name: "机关单位" },
            { img: "", name: "无人停车场" },
        ],
        btn: {
            show: true,
            text: "查看详情",
        },
        param: [
            { key: "产品型号", val: "S260P" },
            { key: "产品尺寸", val: "400mm*300mm*1782mm(头部高755mm)" },
            { key: "产品形态", val: "立柱" },
            { key: "工作温度", val: "-10℃~55℃" },
            { key: "工作湿度", val: "10%-90% RH，不结露" },
            { key: "数据信息管理系统", val: "IriStar Cetus Device 管理平台" },
            { key: "识别方式", val: "远距离虹膜识别、人脸识别、活体检测" },
            {
                key: "活体检测",
                val: "支持静默活体检测/支持打印/显示屏/美瞳/脸膜等假体检测",
            },
            { key: "注册时间", val: "<3s" },
            { key: "识别时间", val: "<1s" },
            { key: "识别环境", val: "室内、半室内、夜晚、逆光均可" },
            { key: "操作系统", val: "Windows 7 64-bit 及以上/Linux/Android" },
            { key: "识别模式", val: "1:N / 1:1" },
            { key: "识别距离", val: "1m~1.2m" },
            { key: "虹膜识别身高范围", val: "1.50~1.90m" },
            { key: "识别误识率", val: "0.00001%" },
            { key: "识别拒识率", val: "0.1%" },
            { key: "虹膜图像", val: "符合ISO29794-6和ISO19794-6标准" },
            { key: "人脸图像", val: "符合ISO29794-5和ISO19794-5标准" },
            {
                key: "近红外光源",
                val: "LED光源符合IEC62471: 2006 无伤害类标准",
            },
            { key: "工作模式", val: "单机模式/联网模式" },
        ],
    },
    {
        imgPo: "imgLeft",
        toHomeImg: "/static/img/product/13.png",
        type: "S330B",
        name: "壁挂式虹膜人脸识别一体机",
        title: "壁挂式虹膜人脸识别一体机",
        img: "/static/img/product/14.png",
        point: ["极速面部特征识别", "双重活体检测", "灵活通关、快捷部署"],
        desc:
            "极速面部特征识别速度快（人脸<1s、虹膜<1.5s）;虹膜人脸双活体检测实现超高安全性；四种通关方式随意组合、快速切换；支持组网应用，2小时完成安装部署。",
        fc: [
            { img: "", name: "极速识别" },
            { img: "", name: "活体检测" },
            { img: "", name: "快捷部署" },
        ],
        btn: {
            show: true,
            text: "查看详情",
        },
        param: [
            { key: "型号", val: "S330B" },
            { key: "产品尺寸", val: "148mm*248mm*33.5mm" },
            { key: "产品功能", val: "1、虹膜注册、虹膜识别、虹膜通关、虹膜考勤；" },
            { key: "", val: "2、人脸注册、人脸识别、人脸通过、人脸考勤、人证核验(可选)" },
            {
                key: "注册信息采集方式",
                val: "1、使用采集器采集信息，通过智慧识别系统实现信息绑定；",
            },
            { key: "", val: "2、非接触、自动触发本地采集，自动同步" },
            { key: "", val: "3、支持信息更新。" },
            { key: "识别距离", val: "40cm — 80cm" },
            { key: "识别身高范围", val: "支持根据用户身高自动调节，覆盖范围可达50cm" },
            { key: "平均注册时间", val: "＜3s" },
            { key: "平均识别时间", val: "＜1s" },
            { key: "用户容量", val: "50000人" },
            { key: "精准度", val: "FAR<0.0001%,FRR<0.1%" },
            { key: "识别/通关方式", val: "1、任意单目，双目虹膜；" },
            { key: "", val: "2、人脸；" },
            { key: "", val: "3、虹膜人脸融合;" },
            { key: "", val: "4、密码输入；" },
            { key: "", val: "5、支持NFC，可与1、2、3、4任意模式与或配置" },
        ],
    },
    {
        imgPo: "imgLeft",
        toHomeImg: "/static/img/product/S310.png",
        type: "S310",
        name: "多模态虹膜人脸一体机",
        title: "多模态虹膜人脸一体机",
        img: "/static/img/product/S310.png",
        point: ["低成本", "真性能", "多模态"],
        desc: "多模态人脸识别一体机具有极速面部特征识别速度快（人脸＜1s，虹膜＜1.5s），虹膜人脸双活体检测实现超高安全性的特点；在虹膜、人脸四种组合方式基础上支持IC卡，通行更便捷；支持wifi/4g/以太网等常规组网方式，快速部署；支持IPX56防护等级，应对复杂场景。",
        fc: [
            { img: "", name: "低成本" },
            { img: "", name: "真性能" },
            { img: "", name: "多模态" },
        ],
        btn: {
            show: true,
            text: "查看详情",
        },
        param: [
            { key: "产品名称", val: "多模态虹膜人脸一体机" },
            { key: "型号", val: "S310" },
            { key: "产品尺寸", val: "150mm*150mm33.5mm" },
            { key: "识别距离", val: "虹膜：30~45cm 人脸：30~100cm NFC卡：0~3cm" },
            { key: "识别身高范围", val: "支持用户手动调节设备安装倾角，支持140cm~190cm身高覆盖；需主动适应；" },
            { key: "平均注册时间", val: "<2s" },
            { key: "平均识别时间", val: "<1s" },
            { key: "用户容量", val: "<10000" },
            { key: "精确度", val: "FAR<0.0001% FRR<0.1%" },
            { key: "注册信息采集方式", val: "1、使用采集器采集信息，通过智慧识别系统实现信息绑定和下发；<br>2、非接触、自动触发本地采集，自动同步；<br>3、支持信息更新；" },
            { key: "识别/通关方式", val: "1、人员单目，双目虹膜；<br>2、人脸支持白平衡；<br>3、虹膜人脸融合；<br>4、密码输入；<br>5、扫描输入；<br>6、支持NFC，可与1、2、3、4、5任意秘书与或配置；" },
            { key: "交互方式", val: "1、屏幕交互（人脸界面研究区域框图，显示界面美观）；<br>2、语言提示；<br>3、支持戴研究避光斑提示；" },
            { key: "活体功能", val: "1、支持打印/显示屏/脸模等假体检测；<br>2、支持虹膜、人脸单独活体检测，活体检测准确率>90%；" },
            { key: "辅助照明标注", val: "1、红外照明；复合IEC62471:2006无伤害类标准，自动触发；<br>2、可见光照明；支持自动亮度调整，自动触发。" },
            { key: "安装和使用方式", val: "壁挂式、立柱式" },
            { key: "工作功率", val: "<16W（理论估算）" },
            { key: "接口", val: "1、USB2.0； <br>2、百兆网口RJ-45；<br>3、门禁接口：继电器；韦根26/34 in/out；<br>4、DC 12V*3A电源接口（接口类型5.5mm*2.5mm）；支持POE供电（可选）；<br>5、RS232串口；" },
            { key: "工作环境", val: "室内/半室内/室外" },
            { key: "工作温度", val: "-10℃~+50℃" },
            { key: "工作湿度", val: "20%-90%RH，未结露" },
            { key: "设备管理", val: "支持远程管理" },
        ],
    },

    {
        imgPo: "imgLeft",
        showToHome: true,
        index: 2,
        scale: "1-1",
        toHomeImg: "/static/img/product/22.png",
        type: "W200",
        name: "手持式虹膜人脸信息采集设备",
        title: "手持式虹膜人脸信息采集设备",
        img: "/static/img/product/9.png",
        point: ["轻盈手持", "全天候适用", "采集成像超清晰"],
        desc:
            "W200手持式虹膜人脸信息采集设备外观小巧便携，使用不受外界环境好光影响，集虹膜、人脸图像信息注册为一体，注册速度快，可联结打通虹星科技旗下所有虹膜人脸融合识别产品，结合后台信息管理系统，对人员通行记录、外来访客、重要区域权限进行统一管理。",
        fc: [
            { img: "", name: "人员注册" },
            { img: "", name: "虹膜人脸采集" },
        ],
        btn: {
            show: true,
            text: "查看详情",
        },
        param: [
            { key: "产品型号", val: "W200" },
            { key: "产品尺寸", val: "193mm*169mm*74mm" },
            { key: "产品形态", val: "手持/支架固定" },
            { key: "输入接口", val: "USB2.0/3.0" },
            { key: "供电方式", val: "USB供电" },
            { key: "USB线长", val: "1.0m" },
            { key: "功率", val: "5W" },
            { key: "工作距离", val: "10cm" },
            { key: "帧率", val: "30fps" },
            { key: "虹膜图像分辨率", val: "640*480" },
            { key: "辅助对准模式", val: "镜面反馈" },
            { key: "工作温度", val: "0~45℃" },
            { key: "工作湿度", val: "0-90% RH，不结露" },
            {
                key: "近红外光源",
                val: "LED光源符合IEC62471: 2006 无伤害类标准",
            },
            { key: "操作系统", val: "Windows、Linux" },
            { key: "注册时间", val: "<2s" },
            { key: "识别时间", val: "<1s" },
        ],
    },
    {
        imgPo: "imgLeft",
        showToHome: true,
        index: 4,
        scale: "1-1",
        toHomeImg: "/static/img/product/44.png",
        type: "S300-UC",
        name: "桌面式虹膜人脸信息采集设备",
        title: "桌面式虹膜人脸信息采集设备",
        img: "/static/img/product/7.png",
        point: ["便携式插口", "无驱动运行", "高安全加密", "公安虹膜采集建库定制设备"],
        desc:
            "虹星科技自主研发的S300-UC中距离注册识别模块，能够实时快速准备获取用户的双眼虹膜和彩色人脸图像，适用于45~65cm虹膜识别和人脸识别，应用于中距离精准身份识别场景，如有高度保密需求的安防场景或无人支付的商业场景。",
        fc: [
            { img: "", name: "金融银行" },
            { img: "", name: "超商便利" },
            { img: "", name: "政务工作" },
        ],
        btn: {
            show: true,
            text: "查看详情",
        },
        param: [
            { key: "产品型号", val: "S300-UC" },
            { key: "产品尺寸", val: "165mm*60mm*47mm" },
            { key: "虹膜工作距离", val: "45~80cm" },
            { key: "注册时间", val: "<2s" },
            { key: "识别时间", val: "<1s" },
            { key: "近红外光源", val: "LED光源符合IEC62471:2006无伤害类标准" },
            { key: "环境光光源", val: "采用LED白光补光灯" },
            { key: "接口", val: "USB2.0/3.0；5.1*2.1mm电源口" },
            { key: "工作温度", val: "-10°~55°" },
            { key: "工作湿度", val: "0-90% RH，不结露" },
            { key: "开发平台", val: "支持Android、Windows、Linux" },
            { key: "使用环境", val: "室内" },
            { key: "虹膜图像", val: "符合ISO29794-6和ISO19794-6标准" },
            { key: "人脸图像", val: "符合ISO29794-5和ISO19794-5标准" },
        ],
    },
    {
        imgPo: "imgLeft",
        toHomeImg: "/static/img/product/aibox.png",
        type: "AI视觉分析边缘计算盒子",
        name: "",
        label: 1,
        title: "",
        img: "/static/img/product/aibox.png",
        point: ['算力强大', '算法全面', '部署灵活', '兼容性强'],
        desc: "AI视觉分析边缘计算盒子搭载中科虹星自主研发算法，实现着装规范检测、违规动作检测、消防安全检测以及其他定制化分析检测，实现对监控场景下人员、物品、环境核心要素的异常分析，同时配合大屏端、电脑端、移动端APP进行预警推送，极大提高客户运营管理的安全性与便捷性。该产品适用于政务（公安、边检、应急）、企业（药厂、药企、半导体、光学、汽车）等行业。  ",
        fc: [
            { img: "", name: "算力强大" },
            { img: "", name: "算法全面" },
            { img: "", name: "部署灵活" },
            { img: "", name: "兼容性强" },
        ],
        btn: {
            show: true,
            text: "查看详情",
        },
        param: [
            { key: "支持高达 17.6T 的INT8峰值算力", val: "  " },
            { key: "支持 2.2T 的FP32高精度算力", val: "  " },
            { key: "着装规范检测：防护服、发罩、护目镜、口罩等", val: "  " },
            { key: "违规行为检测：离岗、打电话、睡觉、吸烟、越界入侵、偷盗等", val: "  " },
            { key: "消防安全检测：火焰、烟雾、占道等", val: "  " },
            { key: "定制检测：通风橱、“五双”、设备状态等，支持自定义模型训练", val: "  " },
            { key: "支持 -20℃至+60℃ 宽温工作环境", val: "  " },
            { key: "支持 IP40 防护等级", val: "  " },
            { key: "主流高清视频监控：海康、大华、华为等", val: "  " },
            { key: "算法框架：Caffe / Tensorflow / PyTorch / Mxnet / Darknet/ Paddle等", val: "  " },
        ],
    },
    {
        imgPo: "imgLeft",
        toHomeImg: "/static/img/product/aianalyse.png",
        type: "AI视觉分析服务器",
        label: 1,
        name: "",
        title: "",
        img: "/static/img/product/aianalyse.png",
        point: ['算力强大', '算法库全面', '兼容性强'],
        desc: "AI视觉分析服务器搭载中科虹星自主研发算法，实现着装规范检测、违规动作检测、消防安全检测以及其他定制化分析检测，实现对监控场景下人员、物品、环境核心要素的异常分析，同时配合大屏端、电脑端、移动端APP进行预警推送，极大提高了客户运营管理的安全性与便捷性。该产品适用于政务（公安、边检、应急、航天）、企业（药厂、药企、半导体、电子、汽车）等行业。",
        fc: [
            { img: "", name: "算力强大" },
            { img: "", name: "算法库全面" },
            { img: "", name: "部署灵活" },
        ],
        btn: {
            show: true,
            text: "查看详情",
        },
        param: [
            { key: "最大支持 528T 的INT8峰值算力", val: "  " },
            { key: "最大支持 66T 的FP32高精度算力", val: "  " },
            { key: "着装规范检测：防护服、发罩、护目镜、口罩等", val: "  " },
            { key: "违规行为检测：离岗、打电话、睡觉、吸烟、越界入侵、偷盗等", val: "  " },
            { key: "消防安全检测：火焰、烟雾、占道等", val: "  " },
            { key: "定制检测：通风橱、“五双”、设备状态等，支持自定义模型训练", val: "  " },
            { key: "主流高清视频监控：海康、大华、华为等", val: "  " },
            { key: "算法框架：Caffe / Tensorflow / PyTorch / Mxnet / Darknet/ Paddle等", val: "  " },
            { key: "操作系统：CentOS / Ubuntu / Debian", val: "  " },
            { key: "国产CPU：飞腾、海光、申威、龙芯", val: "  " },
            { key: "国产操作系统：麒麟、统信UOS", val: "  " },
        ],
    },
    // {
    //     imgPo: "imgLeft",
    //     showToHome: true,
    //     index: 1,
    //     toHomeImg: "/static/img/product/11.png",
    //     type: "S210G-S320G",
    //     name: "混合生物特征识别智能闸机",
    //     title: "混合生物特征识别智能闸机",
    //     img: "/static/img/product/4.png",
    //     point: ["传统闸机遇上前沿黑科技", "大通量人群通关", "可以如此简单"],
    //     desc:
    //         "S210G/S320G 混合生物特征识别智能闸机实现了“虹膜识别 + 活体检测 + 人证比对”功能的三合一，已在国内多个地区的通关、进站口、边防入境、地铁车站等场景中实现了应用，在大幅保证人员认证安全性的同时，有效提升了安检和监控的效率，满足亿级大通量人群快速身份认证的需求。",
    //     fc: [
    //         { img: "", name: "机关单位" },
    //         { img: "", name: "无人停车场" },
    //     ],
    //     btn: {
    //         show: true,
    //         text: "查看详情",
    //     },
    //     param: [
    //         { key: "产品型号", val: "S210G/S320G" },
    //         { key: "产品尺寸", val: "170mm*130mm*750mm(闸机上位机)" },
    //         { key: "产品形态", val: "立柱" },
    //         { key: "电源电压", val: "AC110-220V±10%，50Hz" },
    //         { key: "外壳材质", val: "1.5mm(可定制2.0mm)厚度304不锈钢拉丝板" },
    //         { key: "功率", val: "40W(峰值)、20W(待机)" },
    //         { key: "工作温度", val: "-10~55℃" },
    //         { key: "工作湿度", val: "0-90% RH，不结露" },
    //         { key: "注册时间", val: "<3s" },
    //         { key: "识别时间", val: "<1s" },
    //         { key: "数据信息管理系统", val: "IriStar Cetus Device 管理平台" },
    //         { key: "识别方式", val: "中/远距离虹膜识别、人脸识别" },
    //         {
    //             key: "活体检测",
    //             val: "支持静默活体检测/支持打印/显示屏/美瞳/脸膜等假体检测",
    //         },
    //         { key: "识别环境", val: "室内、半室内、夜晚、逆光均可" },
    //         { key: "操作系统", val: "Windows 7 64-bit 及以上/Linux/Android" },
    //         { key: "识别模式", val: "1:N / 1:1" },
    //         { key: "识别距离", val: "1m~1.2m(S210G)/45~65cm(S320G)" },
    //         {
    //             key: "虹膜识别身高范围",
    //             val: "1.55~1.85m(可定制，最大1.3~1.95m)",
    //         },
    //         { key: "识别误识率", val: "0.00001%" },
    //         { key: "识别拒识率", val: "0.1%" },
    //         { key: "虹膜图像", val: "符合ISO29794-6和ISO19794-6标准" },
    //         { key: "人脸图像", val: "符合ISO29794-5和ISO19794-5标准" },
    //         {
    //             key: "近红外光源",
    //             val: "LED光源符合IEC62471: 2006 无伤害类标准",
    //         },
    //         { key: "工作模式", val: "单机模式/联网模式" },
    //     ],
    // },
    // {
    //     imgPo: "imgLeft",
    //     toHomeImg: "/static/img/product/33.png",
    //     type: "S320",
    //     name: "壁挂式虹膜人脸识别一体机",
    //     title: "壁挂式虹膜人脸识别一体机",
    //     img: "/static/img/product/8.png",
    //     point: ["不拘泥于空间限制", "悬挂融入使用环境", "呵护您的私密安全"],
    //     desc:
    //         "S320壁挂式混合生物特征识别一体机可同时进行虹膜和人脸融合识别，更安全更便捷；识别模块俯仰角度自动调节，完美使用不同用户身高；镜头自动对焦，自动识别捕捉用户虹膜，使用方便快捷；采用LCD实时反馈的辅助对焦模式，具备与人脸识别相似的使用友好型。",
    //     fc: [
    //         { img: "", name: "园区管理" },
    //         { img: "", name: "考勤打卡" },
    //     ],
    //     btn: {
    //         show: true,
    //         text: "查看详情",
    //     },
    //     param: [
    //         { key: "产品型号", val: "S320" },
    //         { key: "产品尺寸", val: "160mm*260mm*45mm" },
    //         { key: "虹膜识别距离", val: "45cm~65cm" },
    //         {
    //             key: "识别身高范围",
    //             val: "支持根据用户身高自动调节，覆盖范围可达40cm",
    //         },
    //         { key: "人证比对", val: "支持，可选" },
    //         {
    //             key: "活体检测",
    //             val: "支持静默活体检测；/支持打印/显示屏/美瞳/脸膜等假体检测",
    //         },
    //         { key: "注册时间", val: "<3s" },
    //         { key: "识别时间", val: "<1s" },
    //         {
    //             key: "终端注册数据库",
    //             val: "标准10000用户的数据（可根据客户需求定制）",
    //         },
    //         { key: "识别误识率", val: "0.00001%" },
    //         { key: "识别拒识率", val: "0.1%" },
    //         { key: "虹膜图像", val: "符合ISO29794-6和ISO19794-6标准" },
    //         { key: "人脸图像", val: "符合ISO29794-5和ISO19794-5标准" },
    //         {
    //             key: "近红外光源",
    //             val: "LED光源符合IEC62471: 2006 无伤害类标准",
    //         },
    //         { key: "屏幕", val: "标配7寸触摸屏" },
    //         { key: "接口", val: "USB2.0/3.0;网口RJ-45;干接继电器信号" },
    //         { key: "工作温度", val: "0℃~45℃" },
    //         { key: "工作湿度", val: "0~90% RH，不结雾" },
    //     ],
    // },
    // {
    //     imgPo: "imgLeft",
    //     toHomeImg: "/static/img/product/12.png",
    //     type: "F200",
    //     name: "动态人脸识别智慧终端",
    //     title: "动态人脸识别智慧终端",
    //     img: "/static/img/product/12.png",
    //     point: ["快速识别", "接口丰富", "三防产品"],
    //     desc:
    //         "F200动态人脸识别智慧终端采用强悍可靠的海思芯片和Linux操作系统，配深度学习自主研发核心算法，推出的一款支持10万人脸库，支持活体检测，适配各种恶劣光线环境，真正满足户外环境使用的动态人脸识别智慧终端。",
    //     fc: [
    //         { img: "", name: "人脸识别" },
    //         { img: "", name: "强悍可靠芯片" },
    //     ],
    //     btn: {
    //         show: true,
    //         text: "查看详情",
    //     },
    //     param: [
    //         { key: "产品型号", val: "F200" },
    //         { key: "处理器", val: "Hi3516CV500,双核Cortex A7@900M,0.5Tops NNIE FPU" },
    //         { key: "DDR3", val: "512MB (选配1GB)" },
    //         { key: "Flash", val: "2GB（可扩展至4/8GB）" },
    //         { key: "最大用户数", val: "5000人（可扩容至2W人）" },
    //         { key: "活体检测", val: "支持静默活体检测；/支持打印/显示屏/美瞳/脸膜等假体检测" },
    //         { key: "显示屏", val: "8寸，IPS，分辨率：800*1280" },
    //         { key: "触摸屏（选配）", val: "G+G电容防爆触摸屏" },
    //         { key: "摄像头", val: "高清200万像素，宽动态，单目摄像头" },
    //         { key: "红外测温模块", val: "测量精度：读数的+/-1.5%   温度分辨率：0.1℃" },
    //         { key: "操作系统", val: "Linux" },
    //         { key: "识别模式", val: "1：N 人脸识别" },
    //         { key: "", val: "2：1 人证核验" },
    //         { key: "活体检测", val: "单目活体" },
    //         { key: "通讯协议", val: "MQTT/Http/Https/Socket等多种协议" },
    //         { key: "SDK", val: "完整的开发文档，支持第三方平台对接" },
    //         { key: "自主开发平台", val: "支持中科虹星智慧识别系统平台" },
    //         { key: "以太网", val: "10/100/1000自适应" },
    //         { key: "USB", val: "2个" },
    //         { key: "4G网络（选配）", val: "4G全网通" },
    //         { key: "WiFi（选配）", val: "IEEE802.11a/b/g/n" },
    //         { key: "RS485", val: "支持" },
    //         { key: "韦根输入，输出", val: "Weigand26/34" },
    //         { key: "开关量输出", val: "NC,COM,NO" },
    //         { key: "IO输出", val: "IN,OUT" },
    //         {
    //             key: "读卡器 RFID（选配）",
    //             val: "ISO/IEC 14443 A&B、NFC、Mifare1卡，读卡距离1-5cm，13.56MHz",
    //         },
    //         { key: "身份证读头（选配）", val: "支持USB外接" },
    //         { key: "USB AP", val: "支持USB外接" },
    //         { key: "身份证读头（选配）", val: "支持" },
    //         { key: "电源", val: "12V,2A" },
    //         { key: "工作温度", val: "–20℃至60℃" },
    //         { key: "储存温度", val: "–30℃至70℃" },
    //         { key: "环境湿度", val: "5%RH-95%RH （无凝结）" },
    //         { key: "防水等级", val: "IP65" },
    //     ],
    // },
    // {
    //     imgPo: "imgLeft",
    //     toHomeImg: "/static/img/product/13.png",
    //     type: "IriSign",
    //     name: "虹膜加密认证U盘",
    //     title: "虹膜加密认证U盘",
    //     img: "/static/img/product/13.png",
    //     point: ["本地加密，双重安全", "智能开启，瞬间解锁", "轻盈手持，即插即用"],
    //     desc:
    //         "IriSign虹膜加密认证U盘，外观小巧便携，轻盈手持，即插即用。采用高安全的生物识别技术，通过高分辨率镜头精准捕捉，无需联网，即可完成虹膜录入与验证，保障信息安全。",
    //     fc: [
    //         { img: "", name: "双重安全" },
    //         { img: "", name: "瞬间解锁" },
    //         { img: "", name: "即插即用" },
    //     ],
    //     btn: {
    //         show: true,
    //         text: "查看详情",
    //     },
    //     param: [
    //         { key: "型号", val: "Iristar S1" },
    //         { key: "识别方式", val: "双目注册" },
    //         { key: "尺寸", val: "77*23*11mm" },
    //         { key: "重量", val: "27g" },
    //         { key: "功率", val: "2.1W" },
    //         { key: "工作距离", val: "15-25cm" },
    //         { key: "输入接口", val: "TYPE-C USB3.0" },
    //         { key: "辅助对准", val: "镜面反馈" },
    //         { key: "精准度", val: "FAR<0.0001% FRR<0.1%" },
    //         { key: "识别时间", val: "0.5S" },
    //         { key: "工作环境", val: "室内环境(避免强光直射)" },
    //         { key: "工作温度", val: "0-40℃" },
    //         { key: "存储容量", val: "32G/128G" },
    //     ],
    // },

    // {
    //     imgPo: "imgLeft",
    //     toHomeImg: "/static/img/product/s330t.png",
    //     type: "S330-T",
    //     name: "测温式虹膜人脸识别一体机",
    //     title: "测温式虹膜人脸识别一体机",
    //     img: "/static/img/product/s330t.png",
    //     point: ["无接触检测，安全卫生", "识别效果，准确高效", "即插即用，快速部署"],
    //     desc:
    //         "S330-T虹膜测温门禁集红外测温、虹膜识别、人脸识别于一体，对佩戴口罩、护目镜等高度防护的人员进行快速体温筛查与精准身份识别，既可完成体温异常人员的预警，同时可快速锁定体温异常人员近期接触者身份，实现流动人员的高效安全门禁管控。特别适合于机场、车站等交通枢纽；医院、学校、政府楼宇门禁；工厂、企业、社区出入口等。",
    //     fc: [
    //         { img: "", name: "无接触检测，安全卫生" },
    //         { img: "", name: "识别效果，准确高效" },
    //         { img: "", name: "即插即用，快速部署" },
    //     ],
    //     btn: {
    //         show: true,
    //         text: "查看详情",
    //     },
    //     param: [
    //         { key: "型号", val: "S330-T" },
    //         { key: "产品尺寸", val: "160mm*260mm*45mm （宽*高*厚）" },
    //         { key: "识别距离", val: "身份识别：45~65cm / 体温检测：<5cm" },
    //         { key: "识别身高范围", val: "支持根据用户身高自动调节，覆盖范围可达40cm" },
    //         { key: "注册时间", val: "虹膜+人脸<3s" },
    //         { key: "识别时间", val: "身份识别+体温检测<2s" },

    //         { key: "识别精度", val: "身份识别：五十率为0.00001%时，拒识率≤0.1% / 体温检测：±0.3℃" },
    //         { key: "终端注册数据库", val: "标准1万用户的数据（可根据用户的需求定制）" },
    //         { key: "近红外光源", val: "近红外光，LED光源符合IEC-62471标准" },
    //         { key: "虹膜图像", val: "符合ISO29794-6和ISO19794-6标准" },
    //         { key: "人脸图像", val: "符合ISO29794-5和ISO19794-5标准" },
    //         { key: "语音提示（灯光）", val: "支持" },
    //     ],
    // },

    // {
    //     imgPo: "imgLeft",
    //     toHomeImg: "/static/img/product/F100.jpg",
    //     type: "F100",
    //     name: "人脸识别一体机（安卓)",
    //     title: "人脸识别一体机（安卓)",
    //     img: "/static/img/product/F100.jpg",
    //     point: ["安卓系统，7寸人脸机", "自带4G功能"],
    //     desc:
    //         "产品外观精美，机型紧凑；有金属外壳及塑胶外壳可选；满足多种使用场景。支持刷卡及测温 ",
    //     fc: [
    //         { img: "", name: "安卓系统，7寸人脸机" },
    //         { img: "", name: "自带4G功能" },
    //     ],
    //     btn: {
    //         show: true,
    //         text: "查看详情",
    //     },
    //     param: [
    //         { key: "产品型号", val: "F100" },
    //         { key: "屏幕", val: "7寸，IPS，触摸屏" },
    //         { key: "识别模式", val: "人脸+刷卡+测温" },
    //         { key: "最大用户数", val: "10000人" },
    //         { key: "操作系统", val: "安卓" },
    //         { key: "防水等级", val: "IP65" },
    //         { key: "接口", val: "支持韦根门磁继电器485等接口" },
    //     ],
    // },
    // {
    //     imgPo: "imgLeft",
    //     toHomeImg: "/static/img/product/F100.jpg",
    //     type: "F100(linux)",
    //     name: "人脸识别一体机（Linux)",
    //     title: "人脸识别一体机（Linux)",
    //     img: "/static/img/product/F100.jpg",
    //     point: ["产品外观精美，机型紧凑", "有金属外壳及塑胶外壳可选"],
    //     desc:
    //         "Linux系统，7寸人脸机标配功能： 7寸IPS屏，双目宽动态，1万人脸库 选配功能：WiFi，刷卡，测温；4G；落地支架  ",
    //     fc: [
    //         { img: "", name: "Linux系统" },
    //         { img: "", name: "7寸人脸机" },
    //     ],
    //     btn: {
    //         show: true,
    //         text: "查看详情",
    //     },
    //     param: [
    //         { key: "产品型号", val: "F100" },
    //         { key: "屏幕", val: "7寸，IPS，触摸屏" },
    //         { key: "识别模式", val: "人脸+刷卡+测温" },
    //         { key: "最大用户数", val: "10000人" },
    //         { key: "操作系统", val: "Linux" },
    //         { key: "防水等级", val: "IP65" },
    //         { key: "接口", val: "支持韦根门磁继电器485等接口" },
    //     ],
    // },
    // {
    //     imgPo: "imgLeft",
    //     toHomeImg: "/static/img/product/F300.png",
    //     type: "F300",
    //     name: "人脸健康码识别一体机",
    //     title: "人脸健康码识别一体机",
    //     img: "/static/img/product/F300.png",
    //     point: ["产品外观精美，机型紧凑", "有金属外壳及塑胶外壳可选"],
    //     desc:
    //         "F300人脸健康码识别一体机拥有成熟的APP及云平台，可对接多个省份及地区的健康码；硬件直连支持安卓平台，方便快速对接各地接口；拥有8寸触摸屏，方便操作使用 ",
    //     fc: [
    //         { img: "", name: "安卓系统" },
    //         { img: "", name: "电子哨兵" },
    //         { img: "", name: "人脸识别+健康码（二维码）" },
    //     ],
    //     btn: {
    //         show: true,
    //         text: "查看详情",
    //     },
    //     param: [
    //         { key: "产品型号", val: "F300" },
    //         { key: "屏幕", val: "8寸，IPS，触摸屏" },
    //         { key: "识别模式", val: "人脸识别+测温+二维码+身份证" },
    //         { key: "最大用户数", val: "10000人" },
    //         { key: "操作系统", val: "安卓" },
    //     ],
    // },

    // {
    //     imgPo: "imgLeft",
    //     toHomeImg: "/static/img/product/s.png",
    //     type: "工地人脸识别一体机",
    //     name: "",
    //     title: "工地人脸识别一体机",
    //     img: "/static/img/product/s.png",
    //     point: [],
    //     desc: "工地“炮筒机”，已对接济工网及多个地方平台。7寸，TN屏，Linux系统，单目，1万人脸库 ",
    //     fc: [
    //         // { img: "", name: "安卓系统" },
    //         // { img: "", name: "电子哨兵" },
    //         // { img: "", name: "人脸识别+健康码（二维码）" },
    //     ],
    //     btn: {
    //         show: true,
    //         text: "查看详情",
    //     },
    //     param: [
    //         { key: "产品型号", val: "工地人脸识别一体机  " },
    //         { key: "屏幕", val: "7寸，TN屏屏" },
    //         { key: "识别模式", val: "支持韦跟输入输出" },
    //         { key: "最大用户数", val: "10000人" },
    //         { key: "操作系统", val: "Linux" },
    //     ],
    // },
    // {
    //     imgPo: "imgLeft",
    //     toHomeImg: "/static/img/product/aibox.png",
    //     type: "AI视觉分析边缘计算盒子",
    //     name: "",
    //     label: 1,
    //     title: "",
    //     img: "/static/img/product/aibox.png",
    //     point: ['算力强大', '算法全面', '部署灵活', '兼容性强'],
    //     desc: "AI视觉分析边缘计算盒子搭载中科虹星自主研发算法，实现着装规范检测、违规动作检测、消防安全检测以及其他定制化分析检测，实现对监控场景下人员、物品、环境核心要素的异常分析，同时配合大屏端、电脑端、移动端APP进行预警推送，极大提高客户运营管理的安全性与便捷性。该产品适用于政务（公安、边检、应急）、企业（药厂、药企、半导体、光学、汽车）等行业。 库 ",
    //     fc: [
    //         { img: "", name: "算力强大" },
    //         { img: "", name: "算法全面" },
    //         { img: "", name: "部署灵活" },
    //         { img: "", name: "兼容性强" },
    //     ],
    //     btn: {
    //         show: true,
    //         text: "查看详情",
    //     },
    //     param: [
    //         { key: "支持高达 17.6T 的INT8峰值算力", val: "  " },
    //         { key: "支持 2.2T 的FP32高精度算力", val: "  " },
    //         { key: "着装规范检测：防护服、发罩、护目镜、口罩等", val: "  " },
    //         { key: "违规行为检测：离岗、打电话、睡觉、吸烟、越界入侵、偷盗等", val: "  " },
    //         { key: "消防安全检测：火焰、烟雾、占道等", val: "  " },
    //         { key: "定制检测：通风橱、“五双”、设备状态等，支持自定义模型训练", val: "  " },
    //         { key: "支持 -20℃至+60℃ 宽温工作环境", val: "  " },
    //         { key: "支持 IP40 防护等级", val: "  " },
    //         { key: "主流高清视频监控：海康、大华、华为等", val: "  " },
    //         { key: "算法框架：Caffe / Tensorflow / PyTorch / Mxnet / Darknet/ Paddle等", val: "  " },
    //     ],
    // },
    // {
    //     imgPo: "imgLeft",
    //     toHomeImg: "/static/img/product/aianalyse.png",
    //     type: "AI视觉分析服务器",
    //     label: 1,
    //     name: "",
    //     title: "",
    //     img: "/static/img/product/aianalyse.png",
    //     point: ['算力强大', '算法库全面', '兼容性强'],
    //     desc: "AI视觉分析服务器搭载中科虹星自主研发算法，实现着装规范检测、违规动作检测、消防安全检测以及其他定制化分析检测，实现对监控场景下人员、物品、环境核心要素的异常分析，同时配合大屏端、电脑端、移动端APP进行预警推送，极大提高了客户运营管理的安全性与便捷性。该产品适用于政务（公安、边检、应急、航天）、企业（药厂、药企、半导体、电子、汽车）等行业。",
    //     fc: [
    //         { img: "", name: "算力强大" },
    //         { img: "", name: "算法库全面" },
    //         { img: "", name: "部署灵活" },
    //     ],
    //     btn: {
    //         show: true,
    //         text: "查看详情",
    //     },
    //     param: [
    //         { key: "最大支持 528T 的INT8峰值算力", val: "  " },
    //         { key: "最大支持 66T 的FP32高精度算力", val: "  " },
    //         { key: "着装规范检测：防护服、发罩、护目镜、口罩等", val: "  " },
    //         { key: "违规行为检测：离岗、打电话、睡觉、吸烟、越界入侵、偷盗等", val: "  " },
    //         { key: "消防安全检测：火焰、烟雾、占道等", val: "  " },
    //         { key: "定制检测：通风橱、“五双”、设备状态等，支持自定义模型训练", val: "  " },
    //         { key: "主流高清视频监控：海康、大华、华为等", val: "  " },
    //         { key: "算法框架：Caffe / Tensorflow / PyTorch / Mxnet / Darknet/ Paddle等", val: "  " },
    //         { key: "操作系统：CentOS / Ubuntu / Debian", val: "  " },
    //         { key: "国产CPU：飞腾、海光、申威、龙芯", val: "  " },
    //         { key: "国产操作系统：麒麟、统信UOS", val: "  " },
    //     ],
    // },
];

// 给每一项添加唯一id
const addId = () => {
    for (let i = 0; i < productList.length; i++) {
        productList[i].id = i + 1;
    }
};
addId();

export default productList;
